// main.js

// import "lazysizes"; // For use with lazysizes_support config option

import Dialog from "./scripts/utils/Dialog.js";
import Tooltip from "./scripts/utils/Tooltip.js";
import SyncedInputs from "./scripts/utils/SyncedInputs.js";

import AccessControls from "./scripts/components/AccessControls.js";
import Accordion from "./scripts/components/Accordion.js";
import AnnouncementBanner from "./scripts/components/AnnouncementBanner.js";
import CardCarousel from "./scripts/components/CardCarousel.js";
import CogCredits from "./scripts/components/CogCredits.js";
import CogBooking from "./scripts/components/CogBooking.js";
import EventDetailHeader from "./scripts/components/EventDetailHeader.js";
import LoadMore from "./scripts/components/LoadMore.js";
import FieldSizing from "./scripts/components/FieldSizing.js";
import LoadingIndicator from "./scripts/components/LoadingIndicator.js";
import QuantityInput from "./scripts/components/QuantityInput.js";
import SiteHeader from "./scripts/components/SiteHeader.js";
import SingleSelectGroup from "./scripts/components/SingleSelectGroup.js";
import SpektrixSession from "./scripts/components/SpektrixSession.js";
import SpektrixIframe from "./scripts/components/SpektrixIframe.js";

import VimeoHeroVideo from "./scripts/components/VimeoHeroVideo.js";
import MediaGallery from "./scripts/components/MediaGallery.js";
import GoogleMapsStatic from "./scripts/components/GoogleMapsStatic.js";
import ClockFace from "./scripts/components/ClockFace.js";

// Flex Blocks
import SupportBlock from "./scripts/components/flex/SupportBlock.js";

// @feature custom-seating-plan
// import SeatingPlan from "./scripts/components/SeatingPlan.js";

document.addEventListener("DOMContentLoaded", () => {
    new SpektrixSession();
});
